import { startCase } from 'lodash'
import moment, { Moment } from 'moment'
import { EhrAppointmentRecurrenceDay } from '@src/types.ts'
import { SelectOption } from '@components/CommonSelect.types.ts'
import {
  dayOfWeekToRecurrenceDayLookup,
  TIME_SLOT_FORMAT,
} from '@screens/NutritionistHub/components/UpcomingCalls/constants.ts'

export const toStringOption = (value: number) => ({
  value,
  text: value === -1 ? 'Indefinitely' : value.toString(),
})

export const toStartCaseOption = (value: string) => ({
  value,
  text: startCase(value),
})

export const toTimeSlotOption = (timeSlot: string | Moment) => {
  const momentTime = moment(timeSlot)
  const value = momentTime.format(TIME_SLOT_FORMAT)
  return {
    value,
    text: `${value} - ${momentTime.add(1, 'hour').format(TIME_SLOT_FORMAT)}`,
  }
}

export const buildTimeSlotOptionsFromSlots = (
  slots: string[],
  days: EhrAppointmentRecurrenceDay[],
) => {
  const allSlots: SelectOption[] = []
  const hasAllDays = days.includes(EhrAppointmentRecurrenceDay.All)

  slots
    .filter((slot) => {
      const slotDay = moment(slot).day()
      return hasAllDays || days.includes(dayOfWeekToRecurrenceDayLookup[slotDay])
    })
    .forEach((slot) => {
      const value = moment(slot).format(TIME_SLOT_FORMAT)
      if (!allSlots.find((slot) => slot.value === value)) {
        allSlots.push(toTimeSlotOption(slot))
      }
    })

  return allSlots.sort((a, b) => {
    const timeA = moment(a.value, TIME_SLOT_FORMAT)
    const timeB = moment(b.value, TIME_SLOT_FORMAT)
    return timeA.isBefore(timeB) ? -1 : 1
  })
}
